import styled from '@emotion/styled';
import { css } from '@emotion/core';
import { useTranslation } from 'react-i18next';
import KizenTypography from 'app/kizentypo';
import { borderTight, shadowOverlay } from 'app/colors';
import { fontSizes } from 'app/typography';
import Icon from 'components/Kizen/Icon';

export const DragIcon = styled(Icon)`
  margin-right: 10px;
  ${({ disabled }) =>
    disabled &&
    css`
      pointer-events: none;
    `}
`;

export const TitleWrapper = styled.div`
  display: flex;
`;

export const DateWrapper = styled.div`
  background: var(--color-border-medium-light);
  border-radius: 10px;
  padding: 2px 5px;

  p {
    text-align: center;
  }
`;

export const Time = styled(KizenTypography)`
  color: var(--color-font-placeholder);
`;

export const BubbleWrapper = styled.div`
  && .user-avatar {
    line-height: 17px;
    width: 15px;
    height: 15px;
    overflow: hidden;
    font-size: ${fontSizes.tiny};
  }
  && .user-image {
    width: 15px;
    height: 15px;
  }
`;

const CardWrapper = styled.div`
  position: relative;
  background: var(--color-background-white);
  margin-bottom: 10px;
  padding: 10px;
  ${shadowOverlay}
  ${borderTight}
  border-color: var(--color-border-medium-light);
  width: 100%;

  ${({ isSelected }) =>
    isSelected &&
    css`
      border-color: var(--color-button-secondary-hover);
    `}
`;

const CardTitle = styled.div`
  display: flex;
  justify-content: space-between;

  & > div:first-child {
    display: flex;
    width: calc(100% - 15px);
  }
`;

const SelectedBlock = styled.div`
  position: absolute;
  background: var(--color-button-secondary-hover);
  border-radius: 3px 3px 0 0;
  padding: 3px 0 2px;
  width: 72px;
  text-align: center;
  bottom: 0;
  left: calc(50% - 36px);

  p {
    font-size: ${fontSizes.micro};
    color: var(--color-font-white);
  }
`;

const CardFooter = styled.div`
  display: flex;
  justify-content: space-between;
  padding-top: 12px;

  & > * {
    display: flex;
    align-items: center;
  }

  & > div:first-child {
    width: calc(100% - 15px);
  }
`;

const BaseCard = ({
  isSelected = false,
  title = null,
  children,
  footer = null,
  ...props
}) => {
  const { t } = useTranslation();
  return (
    <CardWrapper isSelected={isSelected} {...props}>
      {title && <CardTitle>{title}</CardTitle>}
      {children}
      {footer && <CardFooter>{footer}</CardFooter>}
      {isSelected && (
        <SelectedBlock>
          <KizenTypography>{t('Selected')}</KizenTypography>
        </SelectedBlock>
      )}
    </CardWrapper>
  );
};

export default BaseCard;
